<template>
    <div>
        Ops... Sua conexão está está com algum problema.
    </div>
</template>

<script>
    export default {
        name: "Offline"
    }
</script>
